import React, { memo } from 'react'

import { Button, Icon, Trash } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const size = { width: '14px', height: '14px' }
const trashIcon = <Icon svgComponent={Trash} color="dark" size={size} notSpaced />

function PreviewWrap({ imageUrl, onRemovePreview: handleRemovePreview, onEdit: handleEdit = undefined }) {
  const t = useTranslation()
  const image = (
    <img
      src={imageUrl}
      alt="Uploaded preview"
      className="image-uploader__preview"
      decoding="async"
    />
  )

  return (
    <div className="image-uploader__preview-wrap">
      {handleEdit ? (
        // A sibling of the remove control, never its parent: a <button> cannot nest another.
        <button
          type="button"
          className="image-uploader__preview-button"
          onClick={handleEdit}
          aria-label={t('shared.actionSelector.imageUploader.preview.edit')}
        >
          {image}
        </button>
      ) : image}
      <Button
        type="secondary"
        variant="only-icon"
        size="tiny"
        icon={trashIcon}
        customClass="image-uploader__remove"
        onClick={handleRemovePreview}
        aria-label="Remove image"
      />
    </div>
  )
}

PreviewWrap.propTypes = {
  imageUrl: string.isRequired,
  onRemovePreview: func.isRequired,
  onEdit: func,
}

export default memo(PreviewWrap)
